import React from "react";
import "./Supply.css";
// import circle from "../../../assets/Frame 2784.png";
// import yellow from "../../../assets/Rectangle 6 Copy 14.png";
// import red from "../../../assets/Rectangle 6 Copy 11.png";
// import blue from "../../../assets/Rectangle 6 Copy 15.png";
// import green from "../../../assets/Rectangle 6 Copy 14 (1).png";
import tokenomics from "../../../assets/tokenomics 1.png";

const Supply = () => {
  return (
    <div className="supply__section">
      <div className="supply__section__header">
        <h1>MUAL TOKEN SUPPLY AND DISTRIBUTION</h1>
      </div>
      <div className="supply__section__content">
        <img src={tokenomics} alt="" />
      </div>
      {/* <div className="supply__section__image">
        <img src={circle} alt="" />
      </div>
      <div className="supply__section__text">
        <h3>Total Supply 200,000,000 MULA</h3>
        <h2>MULA TOKEN SUPPLY AND DISTRIBUTION</h2>

        <div className="total__supply__section">
          <div className="total__supply__section__first__child">
            <ul>
              <li>
                <div className="total__supply__section__first__child__image">
                  <img src={yellow} alt="" />
                </div>
                <span>Token Sale</span>
              </li>
              <li>
                <div className="total__supply__section__first__child__image">
                  <img src={green} alt="" />
                </div>
                <span>Founders</span>
              </li>
              <li>
                <div className="total__supply__section__first__child__image">
                  <img src={blue} alt="" />
                </div>
                <span>Ecosystem</span>
              </li>
              <li>
                <div className="total__supply__section__first__child__image">
                  <img src={red} alt="" />
                </div>
                <span>Advisory</span>
              </li>
            </ul>
          </div>
          <div className="total__supply__section__second__child">
            <ul>
              <li>
                <div className="total__supply__section__second__child__image">
                  <img src={yellow} alt="" />
                </div>
                <span>Exchange & Liquidity</span>
              </li>
              <li>
                <div className="total__supply__section__second__child__image">
                  <img src={green} alt="" />
                </div>
                <span>Rewards & Airdrops</span>
              </li>
              <li>
                <div className="total__supply__section__second__child__image">
                  <img src={blue} alt="" />
                </div>
                <span>Development & Marketing</span>
              </li>
              <li>
                <div className="total__supply__section__second__child__image">
                  <img src={red} alt="" />
                </div>
                <span>Operational Management</span>
              </li>
            </ul>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Supply;
